/**
 * GapsEmptyState.js
 * Shown when no analysis has been run yet.
 */
import React from 'react';
import { Box, Typography, Chip, alpha } from '@mui/material';
import CompareIcon from '@mui/icons-material/Compare';
import { FEATURE_CHIPS } from './constants';

export default function GapsEmptyState() {
    return (
        <Box sx={{
            textAlign: 'center', py: 7, px: 4,
            borderRadius: 3,
            border: `1.5px dashed ${alpha('#6366f1', 0.25)}`,
            background: 'linear-gradient(135deg, rgba(79,70,229,0.03), rgba(168,85,247,0.04))',
        }}>
            <Box sx={{
                width: 88, height: 88, borderRadius: '50%', mx: 'auto', mb: 2.5,
                background: 'linear-gradient(135deg, rgba(99,102,241,0.12), rgba(168,85,247,0.12))',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: `0 0 0 14px ${alpha('#6366f1', 0.05)}, 0 0 0 28px ${alpha('#6366f1', 0.025)}`,
            }}>
                <CompareIcon sx={{ fontSize: 40, color: '#6366f1', opacity: 0.8 }} />
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.75 }}>
                Ready to Find Your Gaps
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 380, mx: 'auto', lineHeight: 1.8, mb: 2.5 }}>
                Enter your content and a competitor's content (or URLs) above, then click{' '}
                <Box component="span" sx={{ color: '#6366f1', fontWeight: 700 }}>Analyse Gaps</Box>{' '}
                to get a full breakdown of what's missing.
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, justifyContent: 'center' }}>
                {FEATURE_CHIPS.map(f => (
                    <Chip
                        key={f} label={f} size="small"
                        sx={{
                            bgcolor: alpha('#6366f1', 0.08), color: '#6366f1',
                            border: `1px solid ${alpha('#6366f1', 0.2)}`,
                            fontWeight: 600, fontSize: '0.74rem',
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
}
